import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { UserService, ProductService, StorageService, HelperService, BaseComponent, environment } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "@mypxplat/xplat/web/core";
import { Hub } from "aws-amplify/utils";
import { fetchAuthSession, signIn, signInWithRedirect } from "aws-amplify/auth";
import { Amplify } from "aws-amplify";
import { ForgotpasswordComponent } from "../forgotpassword/forgotpassword.component";

@Component({
  selector: "myp-authenticate-presonus-user",
  templateUrl: "authenticate-presonus-user.component.html",
  standalone: false,
})
export class AuthenticatePresonusUserComponent extends BaseComponent {
  @Output() idTokenRetrieved: EventEmitter<any> = new EventEmitter();

  public email: string = "";
  public password: string = "";
  public loading: boolean = false;
  public errorMessage: string = "";
  public passwordVisible: boolean = false;

  constructor(
    public userService: UserService,
    public storageService: StorageService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public productService: ProductService,
    public helperService: HelperService,
    public appService: AppService,
    private router: Router,
    private _spin: NgxSpinnerService
  ) {
    super(userService);
  }

  async submit() {
    if (this.email && this.password) {
      try {
        this.loading = true;
        this.errorMessage = "";

        // todo: encrypt password

        this.userService.authenticatePresonusUser(this.email, this.password).subscribe({
          next: (result: any) => {
            this.loading = false;
            this.idTokenRetrieved.emit(result.idToken);
            this.activeModal.close();
          },
          error: (error) => {
            this.loading = false;
            this.errorMessage = this.helperService.retrieveErrorMessage(error);
          },
        });
      } catch (error) {
        this.loading = false;
        this.errorMessage = "An error occurred. Please try again.";
      }
    }
  }

  startForgotPassword() {
    const modalRef = this.appService.showModal(ForgotpasswordComponent, { size: "sm" });
    modalRef.componentInstance.resetPasswordWithEmail = this.email.toLowerCase();
    modalRef.componentInstance.switchToPreSonusPool = true;
  }
}
